// @ai-generated 2026-09-22T14:57:27+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useIsPortalSession } from '@Contexts/session';
import { type ILinkable } from '@Model';
import { type Column, type ILinkInputProperties } from '@synqo/frontend-component-library';
import { type FC, useMemo } from 'react';
import { PortalNamePreview } from './PortalNamePreview';

/** A record a link picker offers, as far as naming it goes. */
export interface OfferedRecord {
    display_string: string;
    external_label: string;
}

/** What a record offered in the portal is called: the operator's name for it there, where they set one. */
export function portalName(record: OfferedRecord): string {
    return record.external_label || record.display_string;
}

const portalNameColumns: Column<OfferedRecord>[] = [
    {
        name: 'display_string',
        label: 'Bezeichnung',
        renderCell: ({ rowData }) => portalName(rowData),
    },
];

/**
 * What a generic link picker has to be told to offer records under their portal name.
 */
export function usePortalLinkPickerProps<TRecord extends ILinkable & OfferedRecord>(): Partial<
    ILinkInputProperties<TRecord>
> {
    const isPortalSession = useIsPortalSession();

    return useMemo(
        () =>
            isPortalSession
                ? {
                      columns: portalNameColumns as Column<TRecord>[],
                      dropdownPreview: PortalNamePreview as FC<TRecord>,
                  }
                : {},
        [isPortalSession],
    );
}
